import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { JoinEventDataObject } from 'models/service';

type JoinEventRequest = {
  email?: string;
  eventId: string;
  exitUrl?: string;
  userIds: string[];
};

export const joinEvent = async ({ email, eventId, exitUrl, userIds }: JoinEventRequest) =>
  apiClient.post<JoinEventDataObject, ApiClientResponse<JoinEventDataObject>>(routes.events.enter(eventId), {
    email,
    exit_uri: exitUrl,
    user_ids: userIds,
  });
